"use strict";
/*
 * Created on 3. 4. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");
/**
 * Specification of bulk update of sellout release items.
 * @author Radek Beran
 */


var SelloutReleaseItemUpdateRequest =
/*#__PURE__*/
function () {
  function SelloutReleaseItemUpdateRequest(updates) {
    _classCallCheck(this, SelloutReleaseItemUpdateRequest);

    this.updates = updates;
  }
  /**
   * Creates a mapping from update to release items
   */


  _createClass(SelloutReleaseItemUpdateRequest, [{
    key: "groupByUpdate",
    value: function groupByUpdate() {
      var group = immutable_1.Map().asMutable();
      this.updates.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            itemKey = _ref2[0],
            itemUpdate = _ref2[1];

        group.set(itemUpdate, (group.get(itemUpdate) || immutable_1.List()).push(itemKey));
      });
      return group.asImmutable();
    }
    /**
     * Returns list of distinct items in update request.
     */

  }, {
    key: "getUpdatedItems",
    value: function getUpdatedItems() {
      return immutable_1.List(immutable_1.Set(this.updates.map(function (update) {
        return update[0];
      })));
    }
    /**
     * Adds new update request into the list.
     *
     * @param item
     */

  }, {
    key: "push",
    value: function push(itemKey, update) {
      return new SelloutReleaseItemUpdateRequest(this.updates.push([itemKey, update]));
    }
  }]);

  return SelloutReleaseItemUpdateRequest;
}();

exports.SelloutReleaseItemUpdateRequest = SelloutReleaseItemUpdateRequest;